import homeheader from "./homeheader.js";
import searchInput from "./searchInput.js";
import riskMonitoring from "./riskMonitoring.js";
import multipleChains from "./multipleChains.js";
import initilarolemenu from "./initilarolemenu.js";
import homeview from "./homeview.js";

export default {
  homeheader,
  searchInput,
  riskMonitoring,
  multipleChains,
  initilarolemenu,
  homeview,
};
